// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2V-aq","col":"styles_col__2Ue9Q","fulfillmentStatus":"styles_fulfillmentStatus__3v7Cp","emailCol":"styles_emailCol__3fi0s"};